import { LabelType } from '@models/label'
import { NewsItemHeaderProps, NewsType } from '@models/news'
import Label from '@components/UI/Label/Label'
import UserAvatar from '@components/UI/UserAvatar/UserAvatar'
import { isMobile } from 'react-device-detect'
import { formatDateLocale } from '@/app/utils/commonFunctions'

const getLabelType = (type: NewsType) => {
    switch (type) {
        case NewsType.COMMUNICATION:
            return LabelType.WARNING
        case NewsType.STORE_VISIT_TOOL:
            return LabelType.GREEN
        case NewsType.PICTURE_MANAGMENT:
            return LabelType.BLUE
        case NewsType.SURVEY:
            return LabelType.SALMON
        case NewsType.IN_PROGRESS:
            return LabelType.WARNING
        case NewsType.TO_BE_RELEASED:
            return LabelType.WARNING
        case NewsType.NEWS:
            return LabelType.DARK_BLUE_LIGHT
    }
}

const NewsItemHeader = (props: NewsItemHeaderProps) => {
    const {
        userName,
        userLastname,
        avatarImage,
        creationDate,
        type,
        typeKey,
        isDetailsMode,
        onBack,
        openActivity,
        userNickname
    } = props

    const newsItemHeaderClass = 'home-news-item-header'

    const backHandler = () => {
        props.onBack()
    }

    return (
        <div className={newsItemHeaderClass}>
            <div className={`${newsItemHeaderClass}__user-container`}>
                {isMobile && isDetailsMode && (
                    <div className={`${newsItemHeaderClass}__back-container`} onClick={backHandler}>
                        <span className="cu cu-arrow-left"></span>
                    </div>
                )}
                <UserAvatar
                    userName={userName}
                    userLastname={userLastname}
                    userNickname={userNickname}
                    avatarImage={avatarImage}
                />
                <div className={`${newsItemHeaderClass}__user-info`}>
                    <div
                        // onClick={openActivity}
                        className={`${newsItemHeaderClass}__user-name text-bold`}>
                        {userNickname ? userNickname : userName}{userNickname ? '' : ' ' + userLastname}
                    </div>
                    <div className={`${newsItemHeaderClass}__creation-date text`}>
                        {formatDateLocale(creationDate)}
                    </div>
                </div>
            </div>
            <div className={`${newsItemHeaderClass}__type`}>
                <Label type={getLabelType(type)}>{typeKey}</Label>
            </div>
        </div>
    )
}

export default NewsItemHeader
